import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateBusinessUnitMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  organisation_id: Types.Scalars["Int"];
}>;

export type CreateBusinessUnitMutation = { __typename?: "mutation_root" } & {
  insert_business_units?: Types.Maybe<
    { __typename?: "business_units_mutation_response" } & {
      returning: Array<
        { __typename?: "business_units" } & Pick<
          Types.Business_Units,
          "id" | "name"
        >
      >;
    }
  >;
};

export const CreateBusinessUnitDocument = gql`
  mutation CreateBusinessUnit($name: String!, $organisation_id: Int!) {
    insert_business_units(
      objects: { name: $name, organisation_id: $organisation_id }
    ) {
      returning {
        id
        name
      }
    }
  }
`;

export function useCreateBusinessUnitMutation() {
  return Urql.useMutation<
    CreateBusinessUnitMutation,
    CreateBusinessUnitMutationVariables
  >(CreateBusinessUnitDocument);
}
